import type { AxiosRequestConfig } from "axios";

import type { PolicyMetaData } from "@/core/types";

import { http } from "../utils/axios.js";

export const publicRequestsTyped = {
  get_policy_metadata: function (): Promise<PolicyMetaData> {
    const config = {
      method: "GET",
      url: "/v1/public/get_policy_metadata",
    } satisfies AxiosRequestConfig;

    // casting is necessary until we add types higher up to the client
    return http(config) as unknown as Promise<PolicyMetaData>;
  },
};
